import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
export function EditEmailNotifications() {
  const navigate = useNavigate();
  const sections = [{
    title: 'Site administrator notifications',
    items: [{
      label: 'Notify the site administrator by email if unallowed request to site occurs',
      checked: true
    }, {
      label: 'Notify admin of bad logins',
      checked: true
    }]
  }, {
    title: 'Orders department notifications',
    items: [{
      label: 'Enable email notifications to the orders department about placed orders',
      checked: true
    }, {
      label: "'Order is processed' notification to orders department",
      checked: false
    }]
  }, {
    title: 'Users department notifications',
    items: [{
      label: "'Profile is created' notification to users department",
      checked: true
    }, {
      label: "'Profile is modified' notification to users department",
      checked: false
    }, {
      label: "'Profile is deleted' notification to users department",
      checked: false
    }]
  }, {
    title: 'Customer notifications',
    items: [{
      label: 'Enable email notifications for customers about initially placed orders',
      checked: true
    }, {
      label: "'Order is processed' notification to customer",
      checked: false
    }, {
      label: "'Order is completed' notification to customer:",
      checked: true
    }, {
      label: "'Order is declined' notification to orders department",
      checked: true
    }, {
      label: "'Profile is created' notification to profile owner:",
      checked: false
    }, {
      label: "'Profile is modified' notification to profile owner",
      checked: false
    }, {
      label: "'Profile is deleted' notification to profile owner",
      checked: false
    }]
  }];
  return <div className="space-y-4" data-id="element-797" data-mp="1ovw5jywvalgg">
      <div className="flex items-center justify-between" data-id="element-798" data-mp="1oz0lftjp35my">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-799" data-mp="23snasot82rdz">
          Edit E-mail Notifications
        </h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/admin-area')} data-id="element-800" data-mp="1yuc0kcz0mev8">
          ← Back to Admin Area
        </Button>
      </div>

      <Card data-id="element-801" data-mp="2mkxwx6znqape">
        <CardContent className="pt-4 pb-6" data-id="element-802" data-mp="2mkpivbrsszcm">
          <form data-id="element-803" data-mp="2hlv2eghazmvo">
            <table className="w-full text-sm" data-id="element-804" data-mp="2hmea74d8ouvz">
              <tbody data-id="element-805" data-mp="2hjibhdtki26h">
                {sections.map(section => <>
                    <tr key={section.title} data-id="element-806" data-mp="31520f0gal25y">
                      <td colSpan={2} className="pt-5 pb-1" data-id="element-807" data-mp="366ho709utms1">
                        <span className="font-bold text-slate-900" data-id="element-808" data-mp="363vfgxb89188">
                          {section.title}
                        </span>
                      </td>
                    </tr>
                    {section.items.map(item => <tr key={item.label} className="border-t border-slate-100" data-id="element-809" data-mp="2igdnb0o1w14q">
                        <td className="py-1.5 pr-4 text-slate-700 w-full" data-id="element-810" data-mp="2n96qvl7s93f8">
                          {item.label}
                        </td>
                        <td className="py-1.5 text-center w-12" data-id="element-811" data-mp="2dgr48aljjqo0">
                          <input type="checkbox" defaultChecked={item.checked} className="rounded border-slate-300 focus:ring-slate-400" data-id="element-812" data-mp="1zhrhj8hl9luh" />
                        </td>
                      </tr>)}
                  </>)}
              </tbody>
            </table>
            <div className="mt-6 pt-4 border-t border-slate-200" data-id="element-813" data-mp="1mqd5vjllbwzg">
              <Button type="submit" data-id="element-814" data-mp="1mok3igi0fyx9">Submit</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>;
}